import DashboardCardQuestions from './DashboardCardQuestions.jsx';
export default DashboardCardQuestions;